import { toast } from "helpers/toastWrapper";
import { ButtonOAuth } from "components/layout/Button/ButtonOAuth";
import api from "helpers/ApiClient";
import GoogleLogoIcon from "../icons/GoogleLogoIcon";
import Block from "components/layout/Block";
import Text from "components/typography/Text";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { trackClickOAuthButton } from "helpers/analytics";

export const GoogleOAuthButton = ({ oAuth, setOAuth, firebaseHashObject }) => {
	const { t } = useTranslation(["landing"]);
	const language = useSelector((state) => state.globalCommon.language);

	return (
		<ButtonOAuth
			$outline
			disabled={oAuth.loading}
			loading={oAuth.loading}
			label={"continueWithGoogle"}
			onClick={() => {
				trackClickOAuthButton({
					method: "oauth",
					provider: "google",
				});

				setOAuth({
					...oAuth,

					loading: true,
				});
				api.get("/authorization/oauth?provider=google")
					.then(({ data } = {}) => {
						if (sessionStorage) {
							sessionStorage.setItem(
								"oAuth",
								JSON.stringify({
									provider: "google",
									initiator: "login",
									token: data.token,
									hashfirebase: firebaseHashObject,
									pathname: location.pathname,
									language,
								})
							);
							window.location.href = data.url;
						} else {
							setOAuth({
								...oAuth,
								token: null,
								loading: false,
							});
						}
					})
					.catch((error) => {
						setOAuth({
							...oAuth,
							loading: false,
						});
						toast.error(error?.response?.data?.error);
					});
			}}
		>
			<Block flex aligntCenter justifyCenter>
				<GoogleLogoIcon customMargin="0 0.5rem 0 0 " />
				<Text>{t("landing:login:continueWithGoogle")} </Text>
			</Block>
		</ButtonOAuth>
	);
};
